// mapToRange(2, 1, 3, 0, 1) => .5
// mapToRange(0.5, -1, 1, 0, 1) => .75

import { invariant } from '../debug/invariant.util';

export const mapToRange: (value: number, fromValue: number, toValue: number, mapFromValue: number, mapToValue: number) => number =
  (value: number, fromValue: number, toValue: number, mapFromValue: number, mapToValue: number) => {
    invariant(!(value < fromValue), `mapToRange was called with value lesser than fromValue`, value, fromValue);
    invariant(!(value > toValue), `mapToRange was called with value greater than toValue`, value, toValue);
    const percent = (value - fromValue) / (toValue - fromValue);
    return percent * (mapToValue - mapFromValue) + mapFromValue;
  };
